<template>
  <router-link to="/" class="link-back">&larr; Home</router-link>
  <h2>Participants</h2>
  <participants-all></participants-all>
</template>